export default __webpack_public_path__ + "static/media/V120_C_BD.7d16204b.pdf";